'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css2 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css3 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 创建/编辑运费模版表单
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('../constants');

var _areas = require('../utils/areas');

var _areas2 = _interopRequireDefault(_areas);

var _shipping_region_input = require('./shipping_region_input');

var _shipping_region_input2 = _interopRequireDefault(_shipping_region_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var ShippingTemplateForm = _react2.default.createClass({
    displayName: 'ShippingTemplateForm',
    onSubmit: function onSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll(function (err, values) {
            console.dir(values);
            if (!err) {
                // store.dispatch(postProduct(values));
            }
        });
    },
    render: function render() {
        var _props = this.props,
            _props$shippingTempla = _props.shippingTemplate,
            shippingTemplate = _props$shippingTempla === undefined ? {} : _props$shippingTempla,
            form = _props.form;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 }
        };
        var tailFormItemLayout = {
            wrapperCol: {
                span: 14,
                offset: 4
            }
        };
        return _react2.default.createElement(
            _form2.default,
            { onSubmit: this.onSubmit },
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { required: true, label: '\u8FD0\u8D39\u6A21\u7248\u540D\u79F0' }),
                getFieldDecorator('name', {
                    rules: [{ required: true, message: '请输入运费模版名称!' }],
                    initialValue: shippingTemplate.name
                })(_react2.default.createElement(_input2.default, { type: 'text', placeholder: '\u8BF7\u8F93\u5165\u8FD0\u8D39\u6A21\u7248\u540D\u79F0' }))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: '\u6240\u5728\u5730\u533A',
                    required: true
                }),
                getFieldDecorator('regions', {
                    rules: [{ required: true, message: '请选择配送区域!' }]
                })(_react2.default.createElement(_shipping_region_input2.default, null))
            ),
            _react2.default.createElement(
                FormItem,
                tailFormItemLayout,
                _react2.default.createElement(
                    _button2.default,
                    { type: 'primary', htmlType: 'submit', size: 'large' },
                    '\u4FDD\u5B58'
                )
            )
        );
    }
});

exports.default = _form2.default.create()(ShippingTemplateForm);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/shipping_template_form.js
// module id = 1528
// module chunks = 0